export const bulkEditConfirmTitle = (count: number) =>
  `Save changes to ${count} transaction${count > 1 ? 's' : ''}?`;

type ResolveBulkEditConfirmArgs = {
  confirmed: boolean;
  dontShowAgain: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
  onDontShowAgain: () => void;
};

// Applies the user's choice. The opt-out is only persisted when they confirm --
// dismissing the dialog discards it.
export const resolveBulkEditConfirm = ({
  confirmed,
  dontShowAgain,
  onConfirm,
  onCancel,
  onDontShowAgain,
}: ResolveBulkEditConfirmArgs) => {
  if (!confirmed) {
    onCancel?.();
    return;
  }
  if (dontShowAgain) {
    onDontShowAgain();
  }
  onConfirm();
};
